"use client";
import Image from "next/image";
import React, { useState, forwardRef } from "react";
import { Input } from "../atoms/input";
import { Listbox, ListboxLabel, ListboxOption } from "../atoms/listbox";
import { type InputProps as HeadlessInputProps } from "@headlessui/react";

const countries = [
  {
    name: "Nigeria",
    iso: "NG",
    code: "+234",
  },
];

export const InputPhone = forwardRef<HTMLInputElement, HeadlessInputProps>(
  ({ title, value, onChange, onPaste, onKeyDown, ...props }, ref) => {
    const [code, setCode] = useState("+234");
    const [inputValue, setInputValue] = useState(code);

    function updateValue(newValue: string) {
      setInputValue(newValue);
      onChange?.({
        target: { value: newValue },
      } as React.ChangeEvent<HTMLInputElement>);
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      let val = e.target.value;
      val = val.replace(/[^0-9+]/g, "").replace(/\s+/g, "");
      if (val.startsWith(code + "0")) {
        val = val.replace(`${code}0`, code);
      }
      updateValue(val);
    }

    function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
      e.preventDefault();
      let val = e.clipboardData.getData("text");
      val = val.replace(/[^0-9+]/g, "").replace(/\s+/g, "");
      if (val.startsWith(code + "0")) {
        val = val.replace(`${code}0`, code);
      } else if (!val.startsWith(code)) {
        if (val.startsWith("0")) {
          val = `${code + val.slice(1)}`;
        } else {
          val = `${code + val}`;
        }
      }
      updateValue(val);
    }

    function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
      if (e.key === "Backspace" && inputValue === code) {
        e.preventDefault();
      }
    }

    return (
      <div className="flex justify-start items-center space-x-2 pt-2.5">
        <div className="w-[9.5rem] md:w-[9rem]">
          <Listbox
            name="countryCode"
            defaultValue="+234"
            onChange={(val) => setCode(val)}>
            {countries.map((country) => (
              <ListboxOption value={country.code} key={country.name}>
                <Image
                  src={`/flags/${country.iso.toLowerCase()}.svg`}
                  className="w-5 sm:w-4"
                  alt="flag"
                  width={10}
                  height={10}
                />
                <ListboxLabel className="max-sm:!ml-0">
                  {country.iso}
                </ListboxLabel>
              </ListboxOption>
            ))}
          </Listbox>
        </div>
        {title === "standalone" ? (
          <Input
            type="tel"
            value={inputValue}
            onChange={handleChange}
            onPaste={handlePaste}
            onKeyDown={handleKeyDown}
          />
        ) : (
          <Input
            type="tel"
            value={inputValue}
            onChange={handleChange}
            onPaste={handlePaste}
            onKeyDown={handleKeyDown}
            ref={ref}
            {...props}
          />
        )}
      </div>
    );
  },
);

InputPhone.displayName = "InputPhone";
